import { type DocBlock } from './_Doc.ts'
import { type EMRKindID, type EMRTypeID } from './_EMR.ts'

export const GAHTTreatmentFeedback_ID = 'imago.gaht.treatment-feedback' as EMRTypeID & EMRKindID

const GAHTTreatmentFeedbackContent__Brand: unique symbol = Symbol()
export type GAHTTreatmentFeedbackContent = DocBlock[] & {[GAHTTreatmentFeedbackContent__Brand]: never}

export function docifyGAHTTreatmentFeedback(feedback: GAHTTreatmentFeedbackContent): DocBlock[] {
	return [
		{ class: 'TITLE', text: "GAHT Treatment Feedback" },
		...feedback,
	]
}
